function clickableCard(element, link) {
    element.addEventListener('click', (e) => {
        e.stopPropagation();

        if (link.hasAttribute('type')) {
            window.open(link, '_blank');
            return;
        }

        window.open(link, '_self');
    });

    element.style.cursor = 'pointer';
    element.classList.add('clickable');
}

const defaultTeasers = document.querySelectorAll('.layout-default-teaser, .layout-default-teaser-news, .section-nearby .vue-teaser-slider .views-row .inner');

if (!_.isEmpty(defaultTeasers)) {
    Array.from(defaultTeasers).forEach(item => {
        if (item.classList.contains('not-clickable')) {
            return;
        }

        let link = item.getElementsByTagName('A')[0];

        clickableCard(item, link);
    });
}

const headerHeight = document.querySelector('#page-wrapper > header')?.offsetHeight;

if (!_.isNil(headerHeight)) {
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
}

const headerC2aHeight = document.querySelector('.section-header-wrapper .field--name-field-header-c2as')?.offsetHeight;

if (!_.isNil(headerC2aHeight)) {
    document.documentElement.style.setProperty('--header-c2a-height', headerC2aHeight + 'px');
}


const instagramItems = document.querySelectorAll('.instagram-feed .feed-item');

if (!_.isEmpty(instagramItems)) {
    Array.from(instagramItems).forEach(item => {
        let link = item.getElementsByTagName('A')[0];

        clickableCard(item, link);
    })
}